import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/icons/icon-swipe.svg'
import _imports_1 from '@/assets/icons/arrow-customize-house-right.svg'
import _imports_2 from '@/assets/icons/arrow-customize-house-left.svg'


const _hoisted_1 = { class: "slider-actions" }
const _hoisted_2 = { class: "label-wr" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = {
  key: 0,
  class: "img-swipe",
  src: _imports_0
}
const _hoisted_5 = { class: "buttons-container" }
const _hoisted_6 = ["id"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "image-text-wr" }
const _hoisted_10 = { class: "image-text" }
const _hoisted_11 = {
  key: 0,
  class: "image-text"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "line"
}
const _hoisted_14 = {
  key: 1,
  class: "controls"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString($setup.props.title), 1),
        _createElementVNode("span", null, _toDisplayString($setup.props.contentTitle), 1),
        ($props.isLogoSwipe && !$setup.isDesktop)
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : _createCommentVNode("", true)
      ])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "line label-separator" }, null, -1)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "buttons-container",
        id: $setup.props.title,
        ref: "buttonsContainer",
        onTouchstart: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onTouchstart && $setup.onTouchstart(...args))),
        onTouchend: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.onTouchEnd && $setup.onTouchEnd(...args))),
        onTouchcancel: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.onTouchCancel && $setup.onTouchCancel(...args))),
        onTouchmove: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.onTouchMove && $setup.onTouchMove(...args)))
      }, [
        _createElementVNode("div", {
          class: "buttons",
          style: _normalizeStyle($setup.containerStyles)
        }, [
          ($props.isLogoSwipe && !$setup.isDesktop)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.props.items, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["button-images", { checkmark: !$props.isHouseSelectSlider ? $setup.props.selectedItem?.id === item.id : $setup.props.selectedItem?._id === item._id }]),
                  key: item.id || item._id,
                  onClick: ($event: any) => ($setup.onSelectItem(item))
                }, [
                  _createElementVNode("img", {
                    class: "image-slider",
                    src: item.mainImages?.[0] || item?.mainImage || item.url,
                    alt: item.name
                  }, null, 8, _hoisted_8),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(item.name), 1),
                    ($setup.props?.showPrice)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.formatPrice(item?.price)), 1))
                      : _createCommentVNode("", true)
                  ])
                ], 10, _hoisted_7))
              }), 128))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.props.items, (item) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: _normalizeClass(["button default button-slider-action", { 'button-checkmark': $setup.isButtonCheckmark(item), 'button-checkmark-not-icon': $setup.isButtonCheckmarkNotIcon(item), 'button-checkmark-width': $setup.isButtonBuilder() }]),
                  key: item.id || item._id,
                  onClick: ($event: any) => ($setup.onSelectItem(item))
                }, _toDisplayString(item.name), 11, _hoisted_12))
              }), 128))
        ], 4)
      ], 40, _hoisted_6),
      ($setup.showControls)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13))
        : _createCommentVNode("", true),
      ($setup.showControls)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("button", {
              class: "button-next",
              onClick: $setup.scrollDesktopRight
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("img", { src: _imports_1 }, null, -1)
            ]))]),
            _createElementVNode("button", {
              class: "button-prev",
              onClick: $setup.scrollDesktopLeft
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("img", { src: _imports_2 }, null, -1)
            ]))])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}